import React, { Component, ReactNode } from 'react';
import SidebarMenu from '../components/sidebar/SidebarMenu';
import SidebarCollapseItem from '../components/sidebar/SidebarCollapseItem';

class Sidebar extends Component {
  public render(): ReactNode {
    return (
      <div
        className={`lg:h-full h-[calc(100vh-8rem)] z-[10] w-full bg-f-black-6 overflow-y-scroll lg:border-none lg:shadow-none shadow-md relative select-none rounded text-2xs`}
      >
        <SidebarCollapseItem />
        <SidebarMenu />
      </div>
    );
  }
}

export default Sidebar;
